import React from 'react';
import { useNavigate } from 'react-router-dom';
import { buildAutomationEditPath } from '../../../../app-routes';
import { Button } from '../../../../components/ui/button';
import type { AutomationTemplate } from '../templates.types';
import rowStyles from './TemplatesTableRow.module.css';

interface TemplatesTableRowProps {
  template: AutomationTemplate;
  isSyncInProgress: boolean;
}

export const TemplatesTableRow: React.FC<TemplatesTableRowProps> = ({
  template,
  isSyncInProgress,
}) => {
  const navigate = useNavigate();

  const handleEditTemplate = () => {
    navigate(buildAutomationEditPath(template.id));
  };
  return (
    <tr
      className={rowStyles.tableRow}
      onClick={isSyncInProgress ? undefined : handleEditTemplate}>
      <td>{template.contents?.name || template.name}</td>
      <td>{template.contents?.description || '-'}</td>
      <td>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleEditTemplate();
          }}
          variant="ghost"
          size="sm"
          disabled={isSyncInProgress}
          className="text-blue-600 hover:text-blue-900">
          Edit
        </Button>
      </td>
    </tr>
  );
};
